/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module MatchModule */

import {
    Component,
    Input,
    OnInit,
} from '@angular/core';

import { SchemaService } from 'ajs/modules/core/services/schema-service';

import {
    ProtocolMatchConfigItem,
} from 'ajs/modules/match/factories/protocol-match.config-item.factory';

import * as globalL10n from 'global-l10n';

const { ...globalL10nKeys } = globalL10n;

/**
 * @description Component to show readonly information for Protocol Match.
 * @author Nitesh Kesarkar
 */
@Component({
    selector: 'protocol-match-readonly',
    templateUrl: './protocol-match-readonly.component.html',
})
export class ProtocolMatchReadonlyComponent implements OnInit {
    @Input()
    public editable: ProtocolMatchConfigItem;

    public readonly globalL10nKeys = globalL10nKeys;

    /**
     * Used to display text label for selected match criteria in template.
     */
    public matchCriteria: string;

    /**
     * Used to display description for HTTPProtocol in template.
     */
    public matchValueDescription: string;

    constructor(private readonly schemaService: SchemaService) {}

    /** @override */
    public ngOnInit(): void {
        this.matchCriteria = this.schemaService.getEnumValueLabel(
            'MatchOperation',
            this.editable.config.match_criteria,
        );
        this.matchValueDescription = this.schemaService.getEnumValueDescription(
            'HTTPProtocol',
            this.editable.config.protocols,
        );
    }
}
